import Can from './components/Can';
import {AbilityContext} from './components/Can';
import {hasAccessFor} from './config/ability';

const RBAC = {
	Can,
	AbilityContext,
	hasAccessFor
}

export default RBAC;
